import { gql } from "@apollo/client"

export const REFRESH_SESSION = gql`
    mutation RefreshSession($input: SessionRegenerateInput!) {
        session: sessionRegenerate(input: $input) {
            sessionToken
        }
    }
`;